import { GEO_AUTO_COMPLETION_REQUEST, GEO_AUTO_COMPLETION_SCHEDULE } from './geoAutocompletion.types'
import { GeoAutocompletionType } from '../../../@types/types'

export const getGeoAutocompletionRequest = (
  input: string,
  requestType: GeoAutocompletionType,
  secondInput?: string
) => ({
  type: GEO_AUTO_COMPLETION_REQUEST,
  payload: { input, requestType, secondInput },
})

export const geoAutocompletionSchedule = () => ({ type: GEO_AUTO_COMPLETION_SCHEDULE })
